<template>
  <a
    :href="url"
    :aria-label="`Navigeer naar ${text}`"
    class="text-white no-underline focus-visible:text-black"
    :class="[isActive ? 'text-display-sm' : 'text-sm']"
  >
    {{ text }}
  </a>
</template>

<script setup lang="ts">
import type { INavLink } from '@/features/navigation/components/NavLink/types/INavLink.ts'

withDefaults(defineProps<INavLink>(), {
  isActive: false,
})
</script>
